import { FiCamera } from 'react-icons/fi'
import { getLocalizedProductText } from './utils/productHelpers'

const PhotoSourceSelector = ({
  onUpload,
  onTakePicture,
  onSelectHairType,
  translations = {},
  language = 'EN',
}) => {
  return (
    <>
      <div className='upload-zone-icon'>
        <FiCamera size={18} />
      </div>

      <div className='upload-zone-text'>
        <strong>
          {getLocalizedProductText({
            translations,
            language,
            keyPath: 'productFlow.photoUpload.choosePhoto',
            fallback: 'Choose how to add your photo',
          })}
        </strong>

        <br />

        {getLocalizedProductText({
          translations,
          language,
          keyPath: 'productFlow.photoUpload.fileHint',
          fallback: 'JPG, PNG or HEIC — max 10 MB',
        })}
      </div>

      <div
        style={{
          display: 'flex',
          gap: '10px',
          marginTop: '10px',
        }}
      >
        <button
          type='button'
          className='upload-send-btn'
          onClick={onUpload}
          style={{ flex: 1 }}
        >
          {getLocalizedProductText({
            translations,
            language,
            keyPath: 'productFlow.photoUpload.upload',
            fallback: 'Upload',
          })}
        </button>

        <button
          type='button'
          className='upload-send-btn'
          onClick={onTakePicture}
          style={{ flex: 1 }}
        >
          {getLocalizedProductText({
            translations,
            language,
            keyPath: 'productFlow.photoUpload.takePicture',
            fallback: 'Take Picture',
          })}
        </button>

        <button
          type='button'
          className='upload-send-btn'
          onClick={onSelectHairType}
          style={{ flex: 1 }}
        >
          {getLocalizedProductText({
            translations,
            language,
            keyPath: 'productFlow.photoUpload.selectHairType',
            fallback: 'Select hair type',
          })}
        </button>
      </div>
    </>
  )
}

export default PhotoSourceSelector